// Angular
import { Injectable } from '@angular/core';

/** Request type for a responsible-gaming action. */
export type ResponsibleGamingType = 'timeout' | 'self-exclude';

/**
 * Pure helpers for the Responsible Gaming panel — keeps message building
 * out of the component (ported from the Ionic profile screen).
 */
@Injectable({ providedIn: 'root' })
export class ResponsibleGamingService {
  /**
   * Build the confirmation prompt for a timeout/self-exclude request
   * @param {ResponsibleGamingType} type Selected request type
   * @param {string | number} days Timeout length in days
   * @param {string | number} selfExclude Self-exclusion length (years, 999 = lifetime)
   * @returns {string} Confirmation message
   */
  buildConfirmationMessage(
    type: ResponsibleGamingType,
    days: string | number,
    selfExclude: string | number
  ): string {
    const option = type === 'self-exclude' ? 'Self-Exclude' : 'Timeout';
    const period = type === 'timeout'
      ? `${days} days`
      : this.selfExcludePeriod(selfExclude);

    return `Are you sure you wish to ${option} from gambling for ${period} beginning now ?`;
  }

  /**
   * Human-readable self-exclusion period (handles the lifetime sentinel)
   * @param {string | number} selfExclude Years, or 999 for lifetime
   * @returns {string} e.g. "1 year", "3 years", "a Lifetime"
   */
  private selfExcludePeriod(selfExclude: string | number): string {
    const value = Number(selfExclude);
    if (value === 1) return `${selfExclude} year`;
    if (value === 999) return 'a Lifetime';
    return `${selfExclude} years`;
  }
}
